import type { IntegrityResult, TransferPhase } from '../lib/transfer/types';

const PHASE_LABELS: Record<TransferPhase, string> = {
  idle: 'Idle',
  'waiting-for-peer': 'Waiting for receiver',
  connecting: 'Connecting',
  negotiating: 'Negotiating',
  transferring: 'Transferring',
  verifying: 'Verifying',
  complete: 'Complete',
  error: 'Error',
  cancelled: 'Cancelled',
};

const PHASE_STYLES: Record<TransferPhase, string> = {
  idle: 'bg-slate-700/40 text-slate-300',
  'waiting-for-peer': 'bg-amber-500/15 text-amber-300',
  connecting: 'bg-sky-500/15 text-sky-300',
  negotiating: 'bg-sky-500/15 text-sky-300',
  transferring: 'bg-brand-500/15 text-brand-300',
  verifying: 'bg-violet-500/15 text-violet-300',
  complete: 'bg-emerald-500/15 text-emerald-300',
  error: 'bg-rose-500/15 text-rose-300',
  cancelled: 'bg-slate-600/30 text-slate-300',
};

export function PhaseBadge({ phase }: { phase: TransferPhase }) {
  const animate = phase === 'transferring' || phase === 'connecting' || phase === 'negotiating';
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium ${PHASE_STYLES[phase]}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full bg-current ${animate ? 'animate-pulse' : ''}`} />
      {PHASE_LABELS[phase]}
    </span>
  );
}

export function IntegrityBadge({ result }: { result: IntegrityResult }) {
  if (result === 'pending') return null;
  const map: Record<Exclude<IntegrityResult, 'pending'>, { label: string; cls: string }> = {
    verified: { label: 'Verified ✓', cls: 'bg-emerald-500/15 text-emerald-300' },
    corrupted: { label: 'Corrupted ✗', cls: 'bg-rose-500/15 text-rose-300' },
    skipped: { label: 'Unverified', cls: 'bg-slate-600/30 text-slate-300' },
  };
  const { label, cls } = map[result];
  return (
    <span className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-medium ${cls}`}>
      {label}
    </span>
  );
}
